import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import styles from './Iframe.module.scss'

const Iframe = ({ src, className, title, style, ...restProps }) => {
  return (
    <iframe
      {...restProps}
      style={style}
      className={classnames(styles.root, className)}
      title={title}
      src={src}
    />
  )
}

Iframe.propTypes = {
  src: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  style: PropTypes.object, // iframes have a default height of 300px, need to manually override if we want it bigger
}

export default Iframe
